import { Injectable } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { HttpClient } from '@angular/common/http';
import {
  signUp,
  confirmSignUp,
  signIn,
  signInWithRedirect,
  getCurrentUser,
  resendSignUpCode,
  type ConfirmSignUpInput,
  type SignInInput,
  resetPassword,
  confirmResetPassword,
  updatePassword,
  type ResetPasswordOutput,
  type ConfirmResetPasswordInput,
  type UpdatePasswordInput,
  confirmSignIn,
  signOut,
} from 'aws-amplify/auth';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
const HASHKEY = "B@j@j@123%&~SSO*7&%";

type SignUpParameters = {
  password: string;
  email: string;
  name: string;
  mobile: string;
};

@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  clientId: string | null = null;
  userPoolId: string = environment.userPoolId;
  rmuserpoolId: string = environment.b2b_user_Pool;
  region: string = 'ap-south-1';

  constructor(private http: HttpClient, private router: Router) { }

  sendOtpUrl: string = environment.sendOtpUrl;
  verifyOtpUrl: string = environment.verifyOtpUrl;
  usercheck: string = environment.usercheck;
  checkssouserStatus: string = environment.checkssouserStatus;
  updateuserstatus: string = environment.updateuserstatus;
  rmstatus: string = environment.rmstatus;
  activeuser: string = environment.activeuser;
  b2buserstatus: string = environment.b2buserstatus;
  b2buserstatusupdate: string = environment.b2buserstatusupdate;
  b2b_usercheck: string = environment.b2b_usercheck;
  userhistory: string = environment.userhistory;
  checkemailexist: string = environment.b2ccheckemailexist;
  b2bcheckmobileexist: string = environment.b2bcheckmobileexist;
  loginattempt: string = environment.loginattempt;
  b2bresetpassword: string = environment.b2bresetpassword;
  getssoToken: string = environment.getSsoToken;
  unifiedUsercheck: string = environment.unifiedUserCheck;
  b2cunifiedUserCheck: string = environment.b2cunifiedUserCheck;
  b2cPasswordreset: string = environment.b2cpasswordreset;
  b2cinserapi: string = environment.b2cinserapi




  configureUserPoolBasedOnClientId(clientId: string | null) {
    if (clientId === environment.b2b_insurance || clientId === environment.retirment_clientid || clientId === environment.surveypro_clientid || clientId === environment.bqdashboard_clientid || clientId === environment.post_retirement_clientid || clientId === environment.b2b_india_bonds_clientid || clientId === environment.DatacloudWM_clientid || clientId === environment.fpb2b_clientid || clientId === environment.digitalrm_clientid) {
      this.userPoolId = this.rmuserpoolId;
    } else {
      this.userPoolId = environment.userPoolId;
    }
  }

  configureOAuth(clientId: string) {
    // console.log('user', this.userPoolId);
    this.configureUserPoolBasedOnClientId(clientId);
    const selectedDomain =
      clientId === environment.b2b_insurance || clientId === environment.retirment_clientid || clientId === environment.surveypro_clientid || clientId === environment.bqdashboard_clientid || clientId === environment.post_retirement_clientid || clientId === environment.b2b_india_bonds_clientid || clientId === environment.DatacloudWM_clientid || clientId === environment.fpb2b_clientid  || clientId === environment.digitalrm_clientid ? environment.b2b_domain : environment.domain;
    // console.log('Selected Domain:', selectedDomain);

    const oauthConfigNPS_Subdomain = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.NPS_subdomain_redirectSignIn_url}`],
      redirectSignOut: [`${environment.NPS_subdomain_redirectSignOut_url}`],
      responseType: 'code' as 'code',
    };

    const oauthConfigBajaj = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.MF_redirectSignIn_url}`],
      redirectSignOut: [`${environment.MF_redirectSignOut_url}`],
      responseType: 'code' as 'code',
    };

    const oauthConfigInsurance = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [
        `${environment.Insurance_redirectSignIn_url}`,
      ],
      redirectSignOut: [
        `${environment.Insurance_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const oauthConfigb2cInsurance = {
      domain: `${environment.domain}`,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [
        `${environment.b2cinsurance_redirectionsignIn_url}`,
      ],
      redirectSignOut: [
        `${environment.b2cinsurance_redirectionsignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const oauthConfigb2cIndiaBonds = {
      domain: `${environment.domain}`,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [
        `${environment.b2c_india_bonds_redirectSignIn_url}`,
      ],
      redirectSignOut: [
        `${environment.b2c_india_bonds_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const employee = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.b2b_insurance_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.b2b_insurance_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };


    const surveypro = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.surveypro_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.surveypro_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const retirement = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.prp_retirment_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.prp_retirment_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const dashboard = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.bqdashboard_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.bqdashboard_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const indiabonds = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.b2bindiabonds_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.b2bindiabonds_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };


    const DatacloudWM = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.DatacloudWM_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.DatacloudWM_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const financialplanning = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.fp_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.fp_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };


      const digitalrm = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.digitalrm_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.digitalrm_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

      const financialplanningb2c = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.fpc_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.fpc_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    }

    const post_retirements = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.postretirement_redirectSignIn_url}`],
      redirectSignOut: [
        `${environment.postretirement_redirectSignOut_url}`,
      ],
      responseType: 'code' as 'code',
    };

    const unified_dashboard = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.unifieddashboard_redirectSignIn_url}`],
      redirectSignOut: [`${environment.unifieddashboard_redirectSignOut_url}`],
      responseType: 'code' as 'code',
    };

    const unified_dashboardcopy = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.unifieddashboardcopy_redirectSignIn_url}`],
      redirectSignOut: [`${environment.unifieddashboardcopy_redirectSignOut_url}`],
      responseType: 'code' as 'code',
    };

    const bcml_insurance = {
      domain: selectedDomain,
      scopes: ['openid', 'email', 'profile'],
      redirectSignIn: [`${environment.bcml_insurance_redirectSignIn_url}`],
      redirectSignOut: [`${environment.bcml_insurance_redirectSignOut_url}`],
      responseType: 'code' as 'code',
    };

    const userPoolConfig = {
      userPoolId: this.userPoolId,
      userPoolClientId: clientId,
      region: this.region,
    };

    let oauthConfig;
    if (clientId === `${environment.nps_subdomain_clientid}`) {
      oauthConfig = oauthConfigNPS_Subdomain;
    }
    else if (clientId === `${environment.mf_clientid}`) {
      oauthConfig = oauthConfigBajaj;
    } else if (clientId === `${environment.insurance_clientid}`) {
      oauthConfig = oauthConfigInsurance;
    } else if (clientId === `${environment.b2c_insurance_clientid}`) {
      oauthConfig = oauthConfigb2cInsurance;
    } else if (clientId === `${environment.b2c_india_bonds}`) {
      oauthConfig = oauthConfigb2cIndiaBonds;
    } else if (clientId === `${environment.b2b_insurance}`) {
      oauthConfig = employee;
    } else if (clientId === `${environment.retirment_clientid}`) {
      oauthConfig = retirement;
    } else if (clientId === `${environment.surveypro_clientid}`) {
      oauthConfig = surveypro;
    } else if (clientId === `${environment.bqdashboard_clientid}`) {
      oauthConfig = dashboard;
    } else if (clientId === `${environment.post_retirement_clientid}`) {
      oauthConfig = post_retirements;
    } else if (clientId === `${environment.b2b_india_bonds_clientid}`) {
      oauthConfig = indiabonds;
    } else if (clientId === `${environment.DatacloudWM_clientid}`) {
      oauthConfig = DatacloudWM;
    } else if (clientId === `${environment.fpb2b_clientid}`) {
      oauthConfig = financialplanning;
    } else if (clientId === `${environment.digitalrm_clientid}`) {
      oauthConfig = digitalrm;
    }
     else if (clientId === `${environment.unifieddashboard}`) {
      oauthConfig = unified_dashboard;
    }else if (clientId === `${environment.unifieddashboardcopy}`) {
      oauthConfig = unified_dashboardcopy;
    } else if (clientId === `${environment.fpb2c_clientid}`) {
      oauthConfig = financialplanningb2c;
    } else if (clientId === `${environment.bcml_insurance}`) {
      oauthConfig = bcml_insurance;
    }
    else {
      throw new Error('Invalid client ID');
    }
    Amplify.configure({
      Auth: {
        Cognito: {
          loginWith: {
            oauth: oauthConfig,
          },
          ...userPoolConfig,
        },
      },
    });
    this.clientId = clientId;
  }


  async handleSignUp({ password, email, name, mobile }: SignUpParameters) {
    try {
      const emailObj = { email: email.trim() };
      const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(emailObj), HASHKEY).toString();
      const response: any = await this.b2ccheckemailexits({ data: ciphertext }).toPromise();
      const body = typeof response.body === 'string' ? JSON.parse(response.body) : response.body;
      // console.log('emailExists', body.exists);
      if (body.exists) {
        throw new Error(
          'Email is already registered. Please use a different email.'
        );
      }

      // If email does not exist, proceed with signup
      const signUpResult = await signUp({
        username: mobile,
        password,
        options: {
          userAttributes: {
            email,
            name,
            phone_number: mobile,
          },
          autoSignIn: true,
        },
      });

      return signUpResult;
    } catch (error) {
      console.error('Error during signup:', error);
      throw error;
    }
  }

  async handleSignUpConfirmation({
    username,
    confirmationCode,
  }: ConfirmSignUpInput) {
    try {
      await confirmSignUp({ username, confirmationCode });
    } catch (error) {
      throw error;
    }
  }
  async handleSignIn({ username, password }: SignInInput) {
    try {
      const user = await signIn({ username, password });
      return user;
    } catch (error) {
      throw error;
    }
  }

  async handleResetPassword(username: string) {
    try {
      const output: ResetPasswordOutput = await resetPassword({ username });
      this.handleResetPasswordNextSteps(output);
    } catch (error) {
      throw error;
    }
  }

  private handleResetPasswordNextSteps(output: ResetPasswordOutput) {
    const { nextStep } = output;
    switch (nextStep.resetPasswordStep) {
      case 'CONFIRM_RESET_PASSWORD_WITH_CODE':
        const codeDeliveryDetails = nextStep.codeDeliveryDetails;
        break;
      case 'DONE':
        break;
    }
  }

  async handleConfirmResetPassword({
    username,
    confirmationCode,
    newPassword,
  }: ConfirmResetPasswordInput) {
    try {
      await confirmResetPassword({ username, confirmationCode, newPassword });
    } catch (error) {
      throw error;
    }
  }

  async handleUpdatePassword({
    oldPassword,
    newPassword,
  }: UpdatePasswordInput) {
    try {
      await updatePassword({ oldPassword, newPassword });
    } catch (error) {
      throw error;
    }
  }

  async handleGoogleSignIn(forceAccountSelection: boolean = false) {
    try {
      const providerConfig: {
        provider: 'Google';
        custom?: { queryParams: { [key: string]: string } };
      } = {
        provider: 'Google',
      };

      if (forceAccountSelection) {
        providerConfig.custom = {
          queryParams: { prompt: 'select_account' },
        };
      }

      await signInWithRedirect(providerConfig);
    } catch (error) {
      console.error('Google Sign-In error:', error);
    }
  }

  async signOut() {
    try {
      await signOut();
      this.router.navigate(['/sign-in'], {
        queryParams: { clientId: this.clientId },
      });
    } catch (error) {
      console.error('Sign-out error:', error);
    }
  }

  async handleRedirectSignIn() {
    try {
      const user = await getCurrentUser();
    } catch (error) {
      console.error('Error fetching user after redirect:', error);
    }
  }

  async handleSignInOTP({ username }: SignInInput) {
    try {
      const { nextStep } = await signIn({
        username,
        options: {
          authFlowType: 'CUSTOM_WITHOUT_SRP',
        },
      });
      return nextStep;
    } catch (error) {
      throw error;
    }
  }

  async verifyOTP(otp: string) {
    try {
      const { nextStep } = await confirmSignIn({
        challengeResponse: otp,
      });
      return nextStep;
    } catch (error) {
      throw error;
    }
  }

  async resendOTP(username: string) {
    try {
      const resendResult = await resendSignUpCode({ username });
      return resendResult;
    } catch (error) {
      throw error;
    }
  }

  sendOtp(obj: any) {
    return this.http.post(this.sendOtpUrl, obj);
  }

  newverifyOtp(obj: any) {
    return this.http.post(this.verifyOtpUrl, obj);
  }

  TokenApi(obj: any) {
    return this.http.post(this.usercheck, obj);
  }

  b2b_TokenApi(obj: any) {
    return this.http.post(this.b2b_usercheck, obj);
  }

  Check_User_Status(obj: any) {
    return this.http.post(this.checkssouserStatus, obj);
  }

  UserUpdate(obj: any) {
    return this.http.post(this.updateuserstatus, obj);
  }

  rmstatuscheck(obj: any) {
    return this.http.post(this.rmstatus, obj);
  }

  useractive(obj: any) {
    return this.http.post(this.activeuser, obj);
  }

  b2b_User_Status(obj: any) {
    return this.http.post(this.b2buserstatus, obj);
  }

  b2b_user_status_update(obj: any) {
    return this.http.post(this.b2buserstatusupdate, obj);
  }

  UserEventHistory(obj: any) {
    return this.http.post(this.userhistory, obj);
  }

  b2ccheckemailexits(obj: any) {
    return this.http.post(this.checkemailexist, obj);
  }

  b2bcheckMobile_exits(obj: any) {
    return this.http.post(this.b2bcheckmobileexist, obj);
  }

  loginattempts(obj: any) {
    return this.http.post(this.loginattempt, obj);
  }

  b2bPasswordReset(obj: any) {
    return this.http.post(this.b2bresetpassword, obj);
  }


  // async getIpAddress(): Promise<string> {
  //   try {
  //     const response = await this.http
  //       .get<{ ip: string }>('https://api64.ipify.org?format=json')
  //       .toPromise();
  //     return response?.ip ?? 'IP not found';
  //   } catch (error) {
  //     console.error('Error fetching IP address:', error);
  //     throw error;
  //   }
  // }

  getSsoToken(obj: any) {
    return this.http.post(this.getssoToken, obj);
  }

  unifiedUserCheck(obj: any) {
    return this.http.post(this.unifiedUsercheck, obj);
  }

  b2CunifiedUserCheck(obj: any) {
    return this.http.post(this.b2cunifiedUserCheck, obj)
  }
  b2cpasswordreset(obj: any) {
    return this.http.post(this.b2cPasswordreset, obj)
  }
  b2cInsertapi(obj: any) {
    return this.http.post(this.b2cinserapi, obj)
  }
}
